import * as _ from 'lodash';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorCodeHelper {
  private errorCodes: string[];

  constructor() {
    this.errorCodes = [];

    // Users
    this.errorCodes['USR001'] =
      "L'utilisateur n'existe pas dans l'Active Directory";
    this.errorCodes['USR002'] = "L'utilisateur existe et est actif";
    this.errorCodes['USR003'] = "L'utilisateur a déjà été importé";
    this.errorCodes['USR004'] = "L'utilisateur n'existe pas";
    this.errorCodes['USR005'] = "L'utilisateur est inactif";

    // Groups
    this.errorCodes['GRP001'] = 'Le groupe existe déjà';
    this.errorCodes['GRP002'] = "Le groupe Superviseur n'existe pas";
    this.errorCodes['GRP003'] = 'Groupe déjà importé';
    this.errorCodes['GRP004'] = "Le groupe n'existe pas";
    this.errorCodes['GRP005'] = "Groupe déjà affecté à l'utilisateur";
    this.errorCodes['GRP006'] = 'Groupe inactif';
    this.errorCodes['GRP007'] = "Groupe a déjà affecté à l'utilisateur";
    this.errorCodes['GRP008'] = 'Le référent du groupe est inactif';
    this.errorCodes['GRP009'] = "Le groupe opérationnel n'existe pas";
    this.errorCodes['GRP010'] = 'Le groupe opérationnel est inactif';
    this.errorCodes['GRP011'] = "Le groupe de validation n'existe pas";
    this.errorCodes['GRP012'] = "Le groupe de contrôle n'existe pas";
    this.errorCodes['GRP013'] = 'Le type du groupe est invalide';
    this.errorCodes['GRP014'] =
      "Le groupe opérationnel n'est pas du type 'Opérationnel'";
    this.errorCodes['GRP015'] =
      "Le groupe de supervision n'est pas du type 'Supervision'";
    this.errorCodes['GRP016'] =
      "Le groupe de contrôle n'est pas du type 'Contrôle'";
    this.errorCodes['GRP017'] =
      "Certains utilisateurs n'ont pas pu être rattaché au groupe";
    this.errorCodes['GRP018'] =
      'Le groupe de contrôle est déjà affecté à un groupe opérationnel';
    this.errorCodes['GRP019'] = 'Le groupe de contrôle est inactif';
    this.errorCodes['GRP020'] = "Le groupe de supervision n'existe pas";
    this.errorCodes['GRP021'] = 'Le groupe de supersivsion est inactif';
    this.errorCodes['GRP022'] = "Le groupe de comptabilité n'existe pas";
    this.errorCodes['GRP023'] = 'Le groupe de comptabilité est inactif';
    this.errorCodes['GRP024'] =
      "Le groupe de comptabilité n'est pas du type 'Comptabilité'";
    this.errorCodes['GRP025'] = 'Le groupe de validation est inactif';
    this.errorCodes['GRP026'] =
      "Le groupe de validation n'est pas du type 'Validation'";
    this.errorCodes['GRP027'] =
      'Le groupe est attaché à des factures BAP non encore validées';
    this.errorCodes['GRP028'] = 'Le groupe existe déjà';
    this.errorCodes['GRP029'] = "Le groupe de consultation n'existe pas";
    this.errorCodes['GRP030'] = 'Le groupe de consultation est inactif';
    this.errorCodes['GRP031'] =
      "Le groupe de consultation n'est pas du type 'Consultation'";
    this.errorCodes['GRP032'] =
      "Un groupe d'un autre type existe avec le même nom";
    this.errorCodes['GRP033'] = "Le groupe d'approbation n'existe pas";
    this.errorCodes['GRP034'] = "Le groupe d'approbation est inactif";
    this.errorCodes['GRP035'] =
      "Le groupe d'approbation n'est pas du type 'Approbation'";
    this.errorCodes['GRP036'] =
      'Le groupe opérationnel ne gère pas les commandes';
    this.errorCodes['GRP037'] =
      'Le groupe opérationnel ne gère pas les factures associées à PPR';

    this.errorCodes['GRP038'] = "La marque n'existe pas";
    this.errorCodes['GRP039'] = "La typologie n'existe pas";
    this.errorCodes['GRP040'] = "L'arborescence n'existe pas'";

    // Recipient entity
    this.errorCodes['RET001'] = 'La société existe et est active';
    this.errorCodes['RET002'] = 'La société existe est inactive';
    this.errorCodes['RET003'] = 'La société a déjà été importée';
    this.errorCodes['RET004'] = "La société n'existe pas";
    this.errorCodes['RET005'] = 'Le groupe a déjà été affecté à la société';
    this.errorCodes['RET006'] = 'Le groupe existe déjà pour cette soricété';
    this.errorCodes['RET007'] =
      'La référence est utilisée sur des factures à traiter';

    // Assets
    this.errorCodes['REF001'] = 'La référece a déjà été importée';
    this.errorCodes['REF002'] = 'La référece existe et est inactive';
    this.errorCodes['REF003'] = 'La référece existe et est active';
    this.errorCodes['REF004'] = 'La référence existe déjà';
    this.errorCodes['REF005'] = "La référence n'existe pas";
    this.errorCodes['REF006'] =
      "La référence n'est pas de type 'frais généraux'";

    // Workflows
    this.errorCodes['WFL001'] = 'Le workflow a déjà été importé';
    this.errorCodes['WFL002'] =
      'Les groupes de validation contient des doublons';
    this.errorCodes['WFL003'] = 'Le workflow est lié à des factures';
    this.errorCodes['WFL004'] =
      'Le montant du déclenchement de validation du 2ème niveau doit être supérieur à celui du premier niveau';
    this.errorCodes['WFL005'] =
      'Les premiers niveaux de validation doivent avoir un montant de déclenchement';
    this.errorCodes['WFL006'] =
      'Le dernier niveau de validation ne doit pas avoir de montant de déclenchement';
    this.errorCodes['WFL007'] =
      'Les montants de déclenchement de validation sont incorrects';
    this.errorCodes['WFL008'] = 'Au moins une étape de validation est requise';
  }

  public getErrorMessage(errorCode: string): string {
    return this.errorCodes[errorCode];
  }
}
